<template>
  <NotificationBase>
    <template v-slot:icon>
      <img
        class="h-full object-center object-contain w-full"
        src="@/assets/icons/note-upgrade.svg">
    </template>
    <template v-slot>
      <span class="text-12px leading-14px">
        Заказ
        <b
          class="cursor-pointer"
          @click="onClick">{{ id }}</b>
        изменил статус на приоритетный
      </span>
    </template>
  </NotificationBase>
</template>

<script>
import NotificationBase from '@/components/Notifications/Core/NotificationBase.vue';

export default {
  props: {
    payload: {
      type: Object,
      required: true,
    },
  },
  components: {
    NotificationBase,
  },
  computed: {
    id() {
      return this.$delve(this.payload, 'orderGotPriority.order.id');
    },
  },
  methods: {
    onClick() {
      this.$router.push({
        name: 'orders.info',
        params: {
          id: this.id,
        },
      });
      this.$bvModal.hide('notifications');
    },
  },
};
</script>
